// extracted by mini-css-extract-plugin
export default {"skeletonCard":"skeletonCard_skeletonCard__AF-NM","card":"skeletonCard_card__gQtiC","distance":"skeletonCard_distance__0K2MD","name":"skeletonCard_name__EYzCJ"};